import type { IconSvgObject } from './types';

const AlarmSmokeIcon: IconSvgObject = [
  ["path", { d: "M2 7V5C2 4.44772 2.44772 4 3 4H21C21.5523 4 22 4.44772 22 5V7C22 7.55228 21.5523 8 21 8H3C2.44772 8 2 7.55228 2 7Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 8L6.44721 10.8944C6.786 11.572 7.47852 12 8.23607 12H15.7639C16.5215 12 17.214 11.572 17.5528 10.8944L19 8H5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 16V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M16 16V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M8 16V20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default AlarmSmokeIcon;
